import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cta-small",
  "use": "icon-arrow--cta-small-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 10\" id=\"icon-arrow--cta-small\"><path d=\"m7.31 9.754-1.05-.93 3.132-3.15H.045v-1.35h9.347L6.26 1.174l1.05-.93L12 5 7.31 9.754Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol